import { useService } from "./service.js";
import { isDefined } from "../utils/index.js";
function isTouchEvent(event) {
  return typeof TouchEvent !== "undefined" && event instanceof TouchEvent;
}
const events = ["mousemove", "touchmove", "mousedown", "touchstart", "mouseup", "touchend"];
function createPointerService(target) {
  function getTargetSize() {
    return isDefined(target) ? target.getBoundingClientRect() : {
      width: window.innerWidth,
      height: window.innerHeight,
      x: 0,
      y: 0
    };
  }
  function updateProps(event) {
    props.event = event;
    const yLast = props.y;
    const xLast = props.x;
    const targetSize2 = getTargetSize();
    let y = isTouchEvent(event) ? event.touches[0]?.clientY : event.clientY;
    y -= targetSize2.y;
    if (y !== props.y) {
      props.y = y;
    }
    let x = isTouchEvent(event) ? event.touches[0]?.clientX : event.clientX;
    x -= targetSize2.x;
    if (x !== props.x) {
      props.x = x;
    }
    props.changed.x = props.x !== xLast;
    props.changed.y = props.y !== yLast;
    props.last.x = xLast;
    props.last.y = yLast;
    props.delta.x = props.x - xLast;
    props.delta.y = props.y - yLast;
    props.max.x = targetSize2.width;
    props.max.y = targetSize2.height;
    props.progress.x = props.x / props.max.x;
    props.progress.y = props.y / props.max.y;
    return props;
  }
  function handleEvent(event) {
    switch (event.type) {
      case "mouseenter":
      case "mousemove":
      case "touchmove":
        trigger(updateProps(event));
        break;
      case "mousedown":
      case "touchstart":
        props.isDown = true;
        trigger(props);
        break;
      case "mouseup":
      case "touchend":
        props.isDown = false;
        trigger(props);
        break;
    }
  }
  const targetSize = getTargetSize();
  const { add, remove, has, trigger, props } = useService({
    props: {
      event: null,
      isDown: false,
      x: targetSize.x / 2,
      y: targetSize.y / 2,
      changed: {
        x: false,
        y: false
      },
      last: {
        x: targetSize.x / 2,
        y: targetSize.y / 2
      },
      delta: {
        x: 0,
        y: 0
      },
      progress: {
        x: 0.5,
        y: 0.5
      },
      max: {
        x: targetSize.width,
        y: targetSize.height
      }
    },
    init() {
      document.documentElement.addEventListener("mouseenter", handleEvent, {
        once: true,
        capture: true
      });
      const options = { passive: true, capture: true };
      for (const event of events) {
        document.addEventListener(event, handleEvent, options);
      }
    },
    kill() {
      for (const event of events) {
        document.removeEventListener(event, handleEvent);
      }
    }
  });
  return {
    add,
    remove,
    has,
    props: () => props
  };
}
const instances = /* @__PURE__ */ new Map();
function usePointer(target) {
  if (!instances.has(target ?? window)) {
    instances.set(target ?? window, createPointerService(target));
  }
  return instances.get(target ?? window);
}
export {
  usePointer as default
};
//# sourceMappingURL=pointer.js.map
